import { render, staticRenderFns } from "./StartupTrackersPopup.vue?vue&type=template&id=7a9df5a2&scoped=true"
import script from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StartupTrackersPopup.vue?vue&type=style&index=0&id=7a9df5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9df5a2",
  null
  
)

export default component.exports